// extracted by mini-css-extract-plugin
module.exports = {"caption-wrapper":"ClosedCaption_caption-wrapper__SWtL9"};